<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            plain
            @click.stop="handleSendRedPacket(scope.row,scope.index)"
          >发红包</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="openDetailVisible()"
          >下载Excel</el-button>
          <!-- <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >批量删除</el-button>-->
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="toDetail(scope.row,scope.index)"
          >领取详情</el-button>
          <el-button
            type="danger"
            size="small"
            v-if="scope.row.status=='WAIT_PAY'"
            plain
            @click.stop="handlePay(scope.row,scope.index)"
          >支付</el-button>
          <!-- <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >删除</el-button>-->
        </template>

        <template
          slot-scope="scope"
          slot="labelNameForm"
        >
          <el-select
            v-model="currClassify"
            clearable
            multiple
            placeholder="请选择标签"
          >
            <el-option
              v-for="item in classifySelects"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="shopInfoForm"
        >
          <el-input
            v-model="shopName"
            disabled
            placeholder="请输入内容"
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="engineerInfoForm"
        >
          <el-input
            v-model="engineerInfo"
            disabled
            placeholder="请输入内容"
          ></el-input>
        </template>
      </avue-crud>

      <el-dialog
        title="发红包"
        :visible.sync="dialogSetTags"
        width="40%"
      >
        <p
          style="width: 100%;text-align: center;margin-bottom:20px"
          v-if="payment=='RANDOM_COLLECTION'"
        >
          当前为拼手气红包，
          <a
            href="#"
            style="text-decoration:none;color:#3085E6;"
            @click="changeType"
          >改为定额红包</a>
        </p>
        <p
          style="width: 100%;text-align: center;margin-bottom:20px"
          v-if="payment=='QUOTA_RECEIVE'"
        >
          当前为定额红包，
          <a
            href="#"
            style="text-decoration:none;color:#3085E6;"
            @click="changeType"
          >改为拼手气红包</a>
        </p>
        <div class="redPacket">
          <el-form :model="redpacketform">
            <el-form-item
              label="红包名称"
              :label-width="formLabelWidth"
              :rules="[{ required: true, message: '请输入红包名称', trigger: 'blur' }]"
            >
              <el-input
                v-model="redpacketform.redPacketName"
                :maxlength="15"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="发放对象"
              :label-width="formLabelWidth"
              :rules="[{ required: true, message: '请选择日期', trigger: 'change' }]"
            >
              <el-select
                v-model="currclientType"
                placeholder="请选择发放对象"
                @change="changeSendType"
              >
                <el-option
                  v-for="item in clientTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label
              :label-width="formLabelWidth"
            >
              <el-select
                v-model="currClassify"
                id="checkLable"
                clearable
                multiple
                placeholder="全部"
                @change="changeTagsPeople(currClassify)"
              >
                <el-option
                  v-for="item in classifySelects"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <div style="display: flex;flex-flow: row;justify-content: space-between;">
                <span style="color:#aaa">共{{totalPeople}}人</span>
                <a
                  href="#/salesCloud/tags"
                  style="text-decoration:none;color:#3085E6;"
                >管理标签</a>
              </div>
            </el-form-item>
            <el-form-item
              label="总金额"
              :label-width="formLabelWidth"
              v-if="payment=='RANDOM_COLLECTION'"
              :rules="[{ required: true, message: '请输入总金额', trigger: 'change' }]"
            >
              <el-input
                type="number"
                :min="0"
                :max="3000"
                v-model="redpacketform.redPacketTotal"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item
              label="单个金额"
              :label-width="formLabelWidth"
              v-if="payment=='QUOTA_RECEIVE'"
              :rules="[{ required: true, message: '请输入单个金额', trigger: 'change' }]"
            >
              <el-input
                type="number"
                :min="0"
                :max="3000"
                v-model="redpacketform.singleMoney"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item
              label="红包个数"
              :label-width="formLabelWidth"
              :rules="[{ required: true, message: '请输入红包个数', trigger: 'change' }]"
            >
              <el-input
                type="number"
                :min="0"
                :max="300"
                v-model="redpacketform.redPacketNumber"
              >
                <template slot="append">个</template>
              </el-input>
            </el-form-item>
            <el-form-item
              label="祝福语"
              :label-width="formLabelWidth"
              :rules="[{ required: true, message: '请输入祝福语', trigger: 'change' }]"
            >
              <el-input
                v-model="redpacketform.blessings"
                :maxlength="25"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="红包有效期"
              :label-width="formLabelWidth"
              :rules="[{ required: true, message: '请选择日期', trigger: 'change' }]"
            >
              <el-date-picker
                v-model="redpacketform.time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <!-- <el-date-picker
                v-model="redpacketform.time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>-->
            </el-form-item>
            <p
              style="width: 100%;text-align: center;margin-top:20px;font-size:20px"
              v-if="payment=='RANDOM_COLLECTION'"
            >
              ￥
              <span style="font-size:20px;">{{redpacketform.redPacketTotal}}</span>
            </p>
            <p
              style="width: 100%;text-align: center;margin-top:20px;font-size:20px"
              v-if="payment=='QUOTA_RECEIVE'"
            >
              ￥
              <span style="font-size:20px;">{{(redpacketform.singleMoney&&redpacketform.redPacketNumber)?redpacketform.redPacketNumber*redpacketform.singleMoney:''}}</span>
            </p>
          </el-form>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="updateSetTags"
          >塞钱进红包</el-button>
          <el-button @click="dialogSetTags = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="payMoneyDialog"
        title="选择支付方式"
        center
        width="550px"
      >
        <div style="font-size: 14px">
          <div style="display: flex;justify-content:center;margin-top:40px">
            <el-radio
              v-model="radio"
              label="BALANCE"
              v-if="isEnough==='false'"
            >
              账户余额(
              <span style="color:red;font-size:12px;">余额不足</span>
              <a
                href="#"
                style="color:#409EFF;text-decoration: underline;margin-left:8px"
                @click="toPayBalance"
              >去充值</a> )
            </el-radio>
            <el-radio
              v-model="radio"
              label="BALANCE"
              v-if="isEnough==='true'"
            >账户余额({{balance}}元)</el-radio>
            <el-radio
              v-model="radio"
              label="WX_PAY"
            >微信支付(需付1%的手续费)</el-radio>
          </div>
        </div>
        <div class="typeButton">
          <el-button
            round
            size="mini"
            @click="immediatePayment"
          >&nbsp;&nbsp;&nbsp;立即支付&nbsp;&nbsp;&nbsp;</el-button>
          <el-button
            round
            type="danger"
            size="mini"
            @click="payMoneyDialog = false"
          >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>
      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          align="center"
        >
          <vue-qr
            :text="config.value"
            :size="200"
          ></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="QRCodeDialog = false">关闭</el-button>
        </el-dialog>
      </template>
      <template>
        <el-dialog
          title="下载Excel"
          :visible.sync="detailVisible"
        >
          <el-form
            :inline="true"
            :model="detailSearch"
            label-width="80px"
            size="small"
          >
            <el-form-item
              label="领取状态"
              :span="6"
            >
              <el-select
                v-model="detailSearch.receiveStatus"
                required
                value-key="value"
              >
                <el-option
                  v-for="status in detailStatusList"
                  :key="status.value"
                  :label="status.label"
                  :value="status"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="红包状态"
              :span="6"
            >
              <el-select
                v-model="detailSearch.status"
                required
                value-key="value"
              >
                <el-option
                  v-for="status in redPacketStatus"
                  :key="status.value"
                  :label="status.label"
                  :value="status"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="领取时间"
              :span="12"
            >
              <el-date-picker
                v-model="detailSearch.startTime_endTime"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="timestamp"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :span="6">
              <el-button
                class="el-button el-button--primary el-button--small"
                @click.stop="downloadExcelRedPacketDetail"
              >
                <i class="el-icon-download"></i>
                下载Excel
              </el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </template>
    </basic-container>
  </div>
</template>

<script>
import { mobileRedPacketOption } from "@/const/salesCloud/mobileRedPacketOption";
import {
  findRedPacketList,
  findLabelList,
  addRedPacket,
  balancePay,
  immediatePay,
  getBalance,
  editTags,
  findRedPacketListDownloadExcel
} from "@/api/salesCloud/mobileRedPacket";
import { DIC } from "@/const/dic";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import VueQr from "vue-qr";
import { excelaxios } from "@/util/excelaxios";
import { exportExcel } from "xlsx-oc";
import { formatterDateToUTC, parseStatus } from "@/util/util";
export default {
  name: "mobileRedPacket",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: mobileRedPacketOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      payMoneyDialog: false,
      dialogSetTags: false,
      loading: false,
      detailVisible: false,
      QRCodeDialog: false,
      radio: "BALANCE",
      config: { value: "" },
      payment: "RANDOM_COLLECTION",
      classifySelects: [],
      clientType: "",
      totalPeople: 0,
      isEnough: "true",
      balance: 0.0,
      totalMoney: 0,
      currClassify: [],
      clientTypes: DIC.TAGS_CLIENT_TYPE,
      detailStatusList: DIC.SALES_RED_PACKED_DETAIL_STATUS,
      redPacketStatus: DIC.SALES_RED_PACKED_STATUS,
      currclientType: "",
      tabelObj: {},
      isType: false,
      detailSearch: {},
      redpacketform: {
        redPacketName: "",
        recipients: "",
        labelIds: [],
        redPacketTotal: "",
        redPacketNumber: 0
      },
      formLabelWidth: "120px",
      ids: "",
      shopName: "",
      engineerInfo: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {},
  props: [],
  methods: {
    toDetail(row) {
      // let query = {
      //   redPacketId:row.id
      // }
      // // console.log(params)
      // this.$router.push({name:"领取详情",query });
      this.$router.push({
        name: "领取详情",
        params: { id: row.id }
      });
    },
    toPayBalance() {
      this.$router.push({ path: "/salesCloud/accountBalance" });
    },
    handlePay(row) {
      console.log(row);
      // row.redPacketTotal
      getBalance().then(res => {
        let data = JSON.parse(res.data);
        this.balance = data.rows[0].balance;
        if (this.balance < row.redPacketTotal) {
          this.isEnough = "false";
        } else {
          this.isEnough = "true";
        }
      });
      this.redPacketId = row.id;
      this.payMoneyDialog = true;
    },
    immediatePayment() {
      if (this.radio == "BALANCE") {
        let params = {
          redPacketId: this.redPacketId
        };
        balancePay(params).then(res => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "支付成功",
              type: "success"
            });
            this.payMoneyDialog = false;
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
          }
        });
      } else {
        let params = {
          redPacketId: this.redPacketId
        };
        immediatePay(params).then(response => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            console.log(data);
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then(res => {
              console.log(res);
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function() {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "支付成功",
                      type: "success"
                    });
                    _this.payMoneyDialog = false;
                    _this.handleList();
                    done();
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then(res => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function() {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "支付成功",
                              type: "success"
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            _this.payMoneyDialog = false;

                            done();
                            console.log("进来了");
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error"
                          });
                          done();
                          console.log("超时", new Date());
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error"
                        });
                        done();
                        console.log("超时", new Date());
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error"
                });
                done();
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            console.log("集合：" + this.config.value);
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
            //???下面的感觉没用
            // done();
            // this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    },
    changeTagsPeople(currClassify) {
      let checkData = this.classifySelects;
      let ids = [];
      checkData.map((item, index) => {
        for (let i = 0; i < checkData.length + 1; i++) {
          if (currClassify[i] == item.id) {
            ids.push(...item.refIds);
          }
        }
      });
      let newIds = Array.from(new Set(ids));
      this.totalPeople = newIds.length;
    },
    changeSendType() {
      this.currClassify = [];
      // this.redpacketform = {};
      let params = {
        clientType: this.currclientType
      };
      findLabelList(params).then(res => {
        console.log(res);
        let data = JSON.parse(res.data);
        console.log(data);
        this.totalPeople = data.all;
        data = data.list.map(item => {
          item.name = item.name + "(" + item.count + ")";
          return item;
        });
        this.classifySelects = data;
      });
    },
    changeType() {
      if (this.payment == "QUOTA_RECEIVE") {
        this.payment = "RANDOM_COLLECTION";
        delete this.redpacketform.singleMoney;
        delete this.redpacketform.redPacketNumber;
      } else {
        this.payment = "QUOTA_RECEIVE";
        delete this.redpacketform.redPacketTotal;
        delete this.redpacketform.redPacketNumber;
      }
    },
    handleSendRedPacket(row, index) {
      console.log(row);
      this.dialogSetTags = true;
      this.redpacketform = {};
      this.clean();
    },
    remoteMethod(query) {
      console.log(query.length);
      if (query.length == 11) {
        // this.loading = true;
        setTimeout(() => {
          //   this.loading = false;
          console.log("远程搜索");
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findLabelList(params).then(res => {
            console.log(res);
            let data = JSON.parse(res.data);
            this.classifySelects = data;
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },
    clean() {
      this.totalPeople = 0;
      this.currClassify = [];
      this.currclientType = "";
      this.classifySelects = [];
    },
    searchClear() {
      this.currClassify = "";
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      params.collectionType = "ORDINARY";
      this.downloadData = params;
      findRedPacketList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.collectionType = "ORDINARY";
      params.size = this.page.pageSize;
      this.downloadData = params;
      findRedPacketList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      console.log(params);
      delete params.createTimeStart;
      delete params.createTimeEnd;
      delete params.startDate;
      delete params.endDate;
      if (
        params.startDate_endDate != null &&
        params.startDate_endDate.length == 2
      ) {
        params.startDate = params.startDate_endDate[0];
        params.endDate = params.startDate_endDate[1];
      }
      if (
        params.createTimeStart_createTimeEnd != null &&
        params.createTimeStart_createTimeEnd.length == 2
      ) {
        params.createTimeStart = params.createTimeStart_createTimeEnd[0];
        params.createTimeEnd = params.createTimeStart_createTimeEnd[1];
      }

      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.collectionType = "ORDINARY";

      console.log(params);
      findRedPacketList(params).then(res => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.collectionType = "ORDINARY";
      params.size = page.pageSize;
      if (params.startDate_endDate) {
        params.startDate = params.startDate_endDate[0];
        params.endDate = params.startDate_endDate[1];
      }
      if (params.createTimeStart_createTimeEnd) {
        params.createTimeStart = params.createTimeStart_createTimeEnd[0];
        params.createTimeEnd = params.createTimeStart_createTimeEnd[1];
      }
      this.downloadData = params;
      console.log(page);
      findRedPacketList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      this.clean();
      console.log(row);
      if (row.clientType == "JOINS_ENGINEER") {
        console.log("JOINS_ENGINEER");
        this.engineerInfo = row.username;
        let params = {
          clientType: row.clientType
        };
        findLabelList(params).then(res => {
          console.log(res);
          let data = JSON.parse(res.data);
          this.classifySelects = data;
        });
      } else if (row.clientType == "JOINS_MERCHANT") {
        this.shopName = row.shopName;
        console.log("JOINS_MERCHANT");
        let params = {
          clientType: row.clientType
        };
        findLabelList(params).then(res => {
          console.log(res);
          let data = JSON.parse(res.data);
          this.classifySelects = data;
        });
      }
      if (row.labelIds) {
        this.currClassify = row.labelIds.split(",");
      }
      this.$refs.crud.rowEdit(row, index);
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        collectionType: "ORDINARY",
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findRedPacketList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(row);
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      // console.log(val);
      // let types = val.map(item => {
      //   return item.clientType;
      // });
      // let length = Array.from(new Set(types)).length;
      // console.log(length);
      // if (length == 1) {
      //   this.isType = true;
      //   let ids = val.map(item => {
      //     return item.id;
      //   });
      //   let clientType = Array.from(new Set(types));
      //   console.log(clientType);
      //   this.clientType = clientType;
      //   this.ids = ids.join(",");
      // } else if (length == 2) {
      //   this.isType = false;
      //   let ids = val.map(item => {
      //     return item.id;
      //   });
      //   this.ids = "";
      // }
      // console.log(this.ids);
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {
      console.log(row);
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    updateSetTags() {
      console.log(this);
      let params = this.redpacketform;
      params.payment = this.payment;
      if (this.currclientType) {
        params.recipients = this.currclientType;
        console.log(this.currclientType);
      } else {
        console.log("currclientType");
        this.$message({
          showClose: true,
          message: "领取对象不能为空",
          type: "error"
        });
        return;
      }
      if (this.currClassify.length > 0) {
        params.labelIds = this.currClassify;
        params.allLabel = false;

        console.log(this.currClassify);
      } else {
        params.allLabel = true;
      }
      if (this.redpacketform.time) {
        params.startDate = this.redpacketform.time[0].getTime();
        params.endDate = this.redpacketform.time[1].getTime();
      } else {
        console.log("false");
        this.$message({
          showClose: true,
          message: "领取时间不能为空",
          type: "error"
        });
        return;
      }
      console.log(this.redpacketform);
      console.log(params);
      if (!this.redpacketform.redPacketName) {
        this.$message({
          showClose: true,
          message: "红包名称不能为空",
          type: "error"
        });
        return;
      }
      if (!this.redpacketform.blessings) {
        this.$message({
          showClose: true,
          message: "祝福语不能为空",
          type: "error"
        });
        return;
      }

      addRedPacket(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增手机红包成功",
            type: "success"
          });
          this.dialogSetTags = false;
          this.handleList();
          console.log(res);
          let data = JSON.parse(res.data);
          console.log(data);
          let row = {};
          row.id = data.id;
          row.redPacketTotal = data.redPacketTotal;
          setTimeout(this.handlePay(row), 2000);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    handleUpdate(row, index, done) {
      let params = {};
      params.labelIds = this.currClassify.join(",");
      params.refIds = row.id;
      console.log(typeof row.id);
      editTags(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    openDetailVisible() {
      this.detailVisible = true;
    },
    downloadExcelRedPacketDetail() {
      let params = new Object();
      if (
        null != this.detailSearch.startTime_endTime &&
        undefined != this.detailSearch.startTime_endTime
      ) {
        params.startTime = this.detailSearch.startTime_endTime[0];
        params.endTime = this.detailSearch.startTime_endTime[1];
      }
      if (null != this.detailSearch.receiveStatus) {
        params.receiveStatus = this.detailSearch.receiveStatus.value;
      }
      if (null != this.detailSearch.status) {
        params.status = this.detailSearch.status.value;
      }
      params.size = this.page.total;
      findRedPacketListDownloadExcel(params).then(res => {
        window.open(res);
      });
      // findRedPacketList(params).then(res => {
      //   let data = JSON.parse(res.data);
      //   const list = data.rows;
      //   for (let i of list) {
      //     console.log(i);
      //     i.payment = parseStatus(DIC.PAYMENT, i.payment);
      //     i.status = parseStatus(DIC.SALES_RED_PACKED_STATUS, i.status);
      //     i.createTime = formatterDateToUTC(i.createTime * 1);
      //     i.startDate_endDate =
      //       formatterDateToUTC(i.startDate) +
      //       "至" +
      //       formatterDateToUTC(i.endDate);
      //   }
      //   const header = [];
      //   for (let i of this.tableOption.column) {
      //     const obj = {};
      //     if (
      //       i.prop == "payTimeInterval" ||
      //       i.prop == "createTimeStart_createTimeEnd"
      //     ) {
      //       ("");
      //     } else {
      //       obj.k = i.prop;
      //       obj.v = i.label;
      //       header.push(obj);
      //     }
      //   }
      //   const fileName = "手机红包.xlsx";
      //   exportExcel(header, list, fileName);
      // });
      // let url = `/joins-sales/v1/redPacket/downloadExcelForAgent?`;
      // excelaxios(url, params);
      //  this.$router.push({ path: 'joins-sales/v1/redPacket/downloadExcel' })
    }
  }
};
</script>

<style lang="scss">
.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 150px;
}
.redPacket {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  margin-left: 10%;
  .content {
    display: flex;
  }
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
